import { type DeliveryShippingType } from '../../api/schema';

interface DeliveryShippingMapping {
    id: DeliveryShippingType;
    title: string;
}

export const DELIVERY_SHIPPING_MAPPING: Record<DeliveryShippingType, DeliveryShippingMapping> = {
    PICKUP_POINT: { id: 'PICKUP_POINT', title: 'ПВЗ' },
    COURIER: { id: 'COURIER', title: 'Курьер' },
    SELF_PICK_UP: { id: 'SELF_PICK_UP', title: 'Самовывоз' },
    MERCHANT_DELIVERY: { id: 'MERCHANT_DELIVERY', title: 'Собственная служба доставки' },
};
